import React from "react";

/**
 * Web container that renders children without animation (ScaleDecorator not supported on web)
 * @param root0 - Component props
 * @param root0.children - React elements to be rendered directly without animation
 */
const ScaleDecoratorContainer = ({ children }: { children: React.ReactNode }) =>
  children;

export default ScaleDecoratorContainer;
